import { render, staticRenderFns } from "./createCompetency.vue?vue&type=template&id=faf70138&"
import script from "./createCompetency.vue?vue&type=script&lang=js&"
export * from "./createCompetency.vue?vue&type=script&lang=js&"
import style0 from "./createCompetency.vue?vue&type=style&index=0&id=faf70138&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports